import { Theme } from '@mui/material';
import { red, orange } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';

export const competitorsFormFieldStyles = {
  listContainer: {
    '& .MuiTableBody-root  .MuiTableCell-root': {
      padding: '0px 16px !important',
    },
  },
  contractsSwitch: {
    marginX: 1,
  },
};

export const useCompetitorsFormFieldStyles = makeStyles<Theme>(theme => ({
  added: {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.primary.dark
      : '#E6ECFF',
  },
  edited: {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.warning.dark
      : orange[100],
  },
  deleted: {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.error.dark
      : red[100],
  },
}));

export const getCompetitorStateColors = (theme: Theme) => ({
  added: theme.palette.mode === 'dark'
    ? theme.palette.primary.dark
    : '#E6ECFF',
  edited: theme.palette.mode === 'dark'
    ? theme.palette.warning.dark
    : orange[100],
  deleted: theme.palette.mode === 'dark'
    ? theme.palette.error.dark
    : red[100],
});
